import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CajerosRoutingModule } from './cajeros-routing.module';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MainComponent } from './components/main/main.component';
import { DialogAddSellerComponent } from './components/dialog-add-seller/dialog-add-seller.component';
import { DialogModifySellerComponent } from './components/dialog-modify-seller/dialog-modify-seller.component';
import { DialogAssingStoreComponent } from './components/dialog-assing-store/dialog-assing-store.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
    declarations: [
        MainComponent,
        DialogAddSellerComponent,
        DialogAssingStoreComponent,
        DialogModifySellerComponent
    ],
    imports: [
        CommonModule,
        CajerosRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        ImportsModule,
        MatCheckboxModule,
        MatSlideToggleModule
    ]
})
export class CajerosModule { }